import endpoints from '@/utils/constants';
import { apiHelper, authHelper } from '@/utils/helpers';

const actions = {
    saveStatus(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('post', `${endpoints.BASE_URL}${endpoints.API.statuses}`, context.state.status).then((res) => {
                if (res.status === 201) {
                    resolve(res.data)
                }
            }).catch(err => {
                reject(err)
            })
        })
    },

    getStatusList(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.statuses}`).then((res) => {
                if (res.status === 200) {
                    context.commit('setStatusList', res.data);
                    resolve(res.data)
                }
            }).catch(err => {
                reject(err);
            })
        })
    },

    fetchStatus(context, statusId) {
        return new Promise((resolve, reject) => {
            apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.statuses}/${statusId}`).then((res) => {
                if (res.status === 200) {
                    resolve(res.data);
                }
            }).catch(err => {
                reject(err);
            })
        })
    },

    updateStatus(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('put', `${endpoints.BASE_URL}${endpoints.API.statuses}/${context.state.status.statusId}`, context.state.status).then((res) => {
                if (res.status === 200) {
                    context.commit('setStatus', res.data);
                    resolve(res);
                }
            }).catch(err => {
                reject(err);
            })
        });
    },

}
export default actions;